export default __webpack_public_path__ + "static/media/EUR.e5e2f74e.svg";